define( function() {
	"use strict";

	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/css/var/rmargin.js
// module id = 49
// module chunks = 0